import { categoryMap, getPrimaryCategories } from '../utilities/Categories';

function sortAlphabetically(list: string[]): string[] {
  return list.sort((a, b) => a.localeCompare(b));
}

export default function useSuggestedCategories(category?: string) {
  if (!category) {
    return sortAlphabetically(getPrimaryCategories());
  }

  // When a primary category is selected, show categories related to that primary category
  if (category && getPrimaryCategories().includes(category)) {
    return sortAlphabetically(categoryMap[category]);
  }

  return [];
}
